module.exports = __webpack_public_path__ + "static/img/servicee-user@2x.532f6458.png";